import { Action } from '@ngrx/store';
import { Status } from '../../interfaces/status.enum';

export enum UserDialogsActionTypes {
  SetManageDialogOpenStatus = '[UserDialogs] Set manage dialog open status',
  SetManageDialogRequestStatus = '[UserDialogs] Set manage dialog API request status',
}

export class SetManageDialogOpenStatus implements Action {
  public readonly type = UserDialogsActionTypes.SetManageDialogOpenStatus;
  constructor(public payload: { open: boolean }) {}
}

export class SetManageDialogRequestStatus implements Action {
  public readonly type = UserDialogsActionTypes.SetManageDialogRequestStatus;
  constructor(public payload: { status: Status; error?: string }) {}
}

export type UserDialogsActions = SetManageDialogOpenStatus | SetManageDialogRequestStatus;
